import React, { useEffect } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import LoginForm from './LoginForm';
import LinkGoogleButton from './LinkGoogleButton';
import { useI18n } from '../../contexts/I18nContext';

interface LinkAccountModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const LinkAccountModal: React.FC<LinkAccountModalProps> = ({ isOpen, onClose }) => {
  const { t } = useI18n();
  
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-4"
          onClick={onClose}
        >
          <motion.div
            initial={{ scale: 0.9, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.9, opacity: 0 }}
            className="bg-white dark:bg-slate-900 rounded-3xl shadow-2xl max-w-md w-full"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="p-6 text-center relative">
              <button onClick={onClose} className="absolute top-3 right-3 px-2 py-1 rounded-lg text-gray-500 hover:bg-gray-100 dark:hover:bg-slate-700" aria-label={t('close')}>
                ✕
              </button>
              <motion.img src="/logo.png" alt="Zeta AI" className="w-14 h-14 mx-auto mb-4" initial={{ y: -10, opacity: 0 }} animate={{ y: 0, opacity: 1 }} />
              <h2 className="text-2xl font-bold mb-1">Vincular cuenta</h2>
              <p className="text-gray-600 dark:text-gray-300 mb-6">Vinculá tu cuenta de Google para poder acceder con ambos métodos</p>

              <LoginForm onSuccess={() => {
                // After successful login, show the link button
                console.log('Login successful, user can now link Google account');
              }} />

              <div className="my-4 text-gray-500">{t('or')}</div>
              <LinkGoogleButton onSuccess={onClose} />
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default LinkAccountModal;
